"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cars = void 0;
var react_1 = __importStar(require("react"));
var useCarsFilterAdmin_1 = require("../../hook/useCarsFilterAdmin");
var messageContext_1 = require("../../hoc/messageContext");
var react_router_dom_1 = require("react-router-dom");
var select_1 = __importDefault(require("antd/es/select"));
var button_1 = __importDefault(require("antd/es/button"));
var typography_1 = __importDefault(require("antd/es/typography"));
var space_1 = __importDefault(require("antd/es/space"));
var table_1 = __importDefault(require("antd/es/table"));
var spin_1 = __importDefault(require("antd/es/spin"));
var Title = typography_1.default.Title;
var Cars = function () {
    var _a = (0, useCarsFilterAdmin_1.useCarsFilterAdmin)(), cars = _a.cars, loading = _a.loading, filters = _a.filters, onFilterChange = _a.onFilterChange, setCars = _a.setCars;
    var _b = (0, messageContext_1.useMessageContext)(), showError = _b.showError, showSuccess = _b.showSuccess;
    var _c = (0, react_1.useState)(false), loadingTask = _c[0], setLoadingTask = _c[1];
    var _d = (0, react_1.useState)(null), taskMessage = _d[0], setTaskMessage = _d[1];
    var deleteCar = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/cars/").concat(id), {
                        method: 'DELETE',
                        headers: {
                            'content-type': 'application/json',
                        },
                    })];
                case 1:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess('Автомобиль успешно удален');
                        setCars(cars.filter(function (car) { return car.id !== id; }));
                    }
                    else {
                        showError('Ошибка при удалении автомобиля');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var runTask = function (taskName) { return __awaiter(void 0, void 0, void 0, function () {
        var controller, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (loadingTask) {
                        return [2 /*return*/]; // Если задача уже выполняется, не запускаем новую
                    }
                    controller = new AbortController();
                    setLoadingTask(true);
                    setTaskMessage("\u0417\u0430\u0434\u0430\u0447\u0430 ".concat(taskName, " \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F..."));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch("".concat(process.env.REACT_APP_BASE_URL, "/run_task"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ task: taskName }),
                            signal: controller.signal,
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        showSuccess("\u0417\u0430\u0434\u0430\u0447\u0430 ".concat(taskName, " \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u0430"));
                        setTaskMessage(null); // Очистить сообщение
                    }
                    else {
                        showError("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u043F\u0443\u0441\u043A\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 ".concat(taskName));
                        setTaskMessage(null); // Очистить сообщение
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    // Явное указание типа ошибки
                    if (error_1 instanceof Error) {
                        if (error_1.name === 'AbortError') {
                            setTaskMessage('Задача отменена');
                        }
                        else {
                            showError("\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u043F\u0443\u0441\u043A\u0435 \u0437\u0430\u0434\u0430\u0447\u0438: ".concat(error_1.message));
                        }
                    }
                    else {
                        showError('Произошла неизвестная ошибка');
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingTask(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: function (a, b) { return a.id - b.id; },
        },
        {
            title: 'Бренд',
            dataIndex: ['brand', 'name'],
            key: 'brand',
        },
        {
            title: 'Модель',
            dataIndex: ['model', 'name'],
            key: 'model',
            sorter: function (a, b) { return a.model.name.localeCompare(b.model.name); },
        },
        {
            title: 'Поколение',
            dataIndex: ['generation', 'name'],
            key: 'generation',
        },
        {
            title: 'Год',
            dataIndex: 'year',
            key: 'year',
            sorter: function (a, b) { return a.year - b.year; },
        },
        {
            title: 'Цена',
            dataIndex: 'price',
            key: 'price',
            sorter: function (a, b) { return Number(a.price) - Number(b.price); },
            render: function (price) { return "".concat(parseInt(price).toLocaleString(), " \u20BD"); },
        },
        {
            title: 'Действия',
            key: 'action',
            render: function (_, record) { return (react_1.default.createElement(space_1.default, { size: "middle" },
                react_1.default.createElement(react_router_dom_1.Link, { to: "/admin/car/".concat(record.id), state: { car: record } }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                react_1.default.createElement("a", { onClick: function () { return deleteCar(record.id); } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"))); },
        },
    ];
    return (react_1.default.createElement("div", { style: { padding: '20px' } },
        react_1.default.createElement(Title, { level: 1 }, "\u041F\u043E\u0438\u0441\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0438\u043B\u044F"),
        react_1.default.createElement(space_1.default, { style: { marginBottom: 24 } },
            react_1.default.createElement(select_1.default, { style: { width: 200 }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0440\u0435\u043D\u0434", value: filters.brand_name.value, onChange: function (value) { return onFilterChange('brand_name', value); }, options: filters.brand_name.selectItems.map(function (brand) { return ({
                    label: brand,
                    value: brand,
                }); }) }),
            react_1.default.createElement(select_1.default, { style: { width: 200 }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043C\u043E\u0434\u0435\u043B\u044C", value: filters.model_name.value, onChange: function (value) { return onFilterChange('model_name', value); }, disabled: filters.brand_name.value === 'Все бренды', options: filters.model_name.selectItems.map(function (model) { return ({
                    label: model,
                    value: model,
                }); }) }),
            react_1.default.createElement(select_1.default, { style: { width: 200 }, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043A\u043E\u043B\u0435\u043D\u0438\u0435", value: filters.generation_name.value, onChange: function (value) { return onFilterChange('generation_name', value); }, disabled: filters.model_name.value === 'Все модели', options: filters.generation_name.selectItems.map(function (generation) { return ({
                    label: generation,
                    value: generation,
                }); }) })),
        react_1.default.createElement(space_1.default, { style: { marginBottom: 16 } },
            react_1.default.createElement(button_1.default, { type: "primary", onClick: function () { return runTask('import_api:delete_diff_cars'); } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0443\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0438\u0435 \u0430\u0432\u0442\u043E"),
            react_1.default.createElement(button_1.default, { type: "primary", onClick: function () { return runTask('import_api:create_cars'); } }, "\u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0432\u0442\u043E"),
            react_1.default.createElement(button_1.default, { type: "primary", onClick: function () { return runTask('import_api:update_cars'); } }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0430\u0432\u0442\u043E")),
        loadingTask && (react_1.default.createElement("div", { style: { marginTop: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '5px' } },
            react_1.default.createElement(spin_1.default, { style: { marginRight: '10px' } }),
            react_1.default.createElement("span", null, taskMessage))),
        react_1.default.createElement(table_1.default, { columns: columns, dataSource: cars, loading: loading, rowKey: "id", pagination: {
                total: cars.length,
                pageSize: 18,
                showSizeChanger: false,
            } })));
};
exports.Cars = Cars;
